var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseSmall2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "close_small"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1109_3195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1109_3195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_small_2",
    d: "M12 13.8033L8.19672 17.6066C7.95628 17.847 7.65027 17.9672 7.27869 17.9672C6.9071 17.9672 6.60109 17.847 6.36066 17.6066C6.12022 17.3661 6 17.0601 6 16.6885C6 16.3169 6.12022 16.0109 6.36066 15.7705L10.1639 11.9672L6.36066 8.19672C6.12022 7.95628 6 7.65027 6 7.27869C6 6.9071 6.12022 6.60109 6.36066 6.36066C6.60109 6.12022 6.9071 6 7.27869 6C7.65027 6 7.95628 6.12022 8.19672 6.36066L12 10.1639L15.7705 6.36066C16.0109 6.12022 16.3169 6 16.6885 6C17.0601 6 17.3661 6.12022 17.6066 6.36066C17.8689 6.62295 18 6.93443 18 7.29508C18 7.65574 17.8689 7.95628 17.6066 8.19672L13.8033 11.9672L17.6066 15.7705C17.847 16.0109 17.9672 16.3169 17.9672 16.6885C17.9672 17.0601 17.847 17.3661 17.6066 17.6066C17.3443 17.8689 17.0328 18 16.6721 18C16.3115 18 16.0109 17.8689 15.7705 17.6066L12 13.8033Z",
    fill: "#333333"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall2);
export default __webpack_public_path__ + "static/media/close_small (2).94459929940827d7a8e0006927a26749.svg";
export { ForwardRef as ReactComponent };